import dynamic from 'next/dynamic'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import SizeChartButtonLegacy, { type SizeChartButtonProps } from './SizeChartButton-legacy'

const SizeChartButtonDS = dynamic(() =>
  import(/* webpackChunkName: "size-chart-button-ds" */ '@src/components/blocks/size-chart-button-ds').then(m => ({
    default: m.SizeChartButtonDS,
  })),
)

const SizeChartButton = (props: SizeChartButtonProps) => {
  if (shouldUseDesignSystem()) {
    return <SizeChartButtonDS {...props} />
  }
  return <SizeChartButtonLegacy {...props} />
}

export type { SizeChartButtonProps }
export default SizeChartButton
